<mat-toolbar class="topbar gap-5">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if (showToggle) {
    <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center align-items-center">
      <i class="iconify icon-20 d-flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Mobile Menu -->
  @if (!showToggle) {
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center align-items-center">
      <i class="iconify icon-20 d-flex" data-icon="solar:hamburger-menu-line-duotone"></i>
    </button>
  }
  <!-- --------------------------------------------------------------- -->

  <!-- --------------------------------------------------------------- -->
  <!--  Search -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button
    mat-icon-button
    (click)="openDialog()"
    class="d-flex align-items-center justify-content-center"
  >
    <i class="iconify icon-20 d-flex" data-icon="solar:magnifer-outline"></i>
  </button> -->

  <div class="d-none d-lg-flex">
    <!-- --------------------------------------------------------------- -->
    <!--  Links -->
    <!-- --------------------------------------------------------------- -->
    <!-- <button
      mat-icon-button
      [matMenuTriggerFor]="appsmenu"
      aria-label="links"
      class="d-flex align-items-center justify-content-center"
    >
      <i
        class="iconify icon-20 d-flex"
        data-icon="solar:widget-3-line-duotone"
      ></i>
    </button> -->
    <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
      <div class="row">
        <div class="col-sm-8 p-r-0">
          <div class="p-32 p-b-0">
            <div class="row">
              @for (appdd of apps; track appdd.title) {
                <div class="col-sm-6 text-hover-primary">
                  <a [routerLink]="[appdd.link]" class="d-flex align-items-center text-decoration-none m-b-24">
                    <span
                      class="text-{{ appdd.color }} bg-light-{{
                        appdd.color
                      }} rounded icon-48 d-flex align-items-center justify-content-center"
                    >
                      <span class="iconify icon-20" [attr.data-icon]="appdd.icon"></span>
                    </span>

                    <div class="m-l-16">
                      <h5 class="f-s-14 f-w-600 m-0 hover-text">
                        {{ appdd.title }}
                      </h5>
                      <span class="f-s-12 text-muted">{{ appdd.subtitle }}</span>
                    </div>
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-4">
          <img src="/assets/images/backgrounds/mega-dd-bg.jpg" alt="mega-dd-bg" class="mega-dd-bg" />
        </div> -->
      </div>
    </mat-menu>
  </div>

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <!-- <button
      mat-icon-button
      (click)="toggleMobileFilterNav.emit()"
      class="d-flex d-lg-none justify-content-center align-items-center"
    >
      <i class="iconify icon-20 d-flex" data-icon="solar:menu-dots-outline"></i>
    </button> -->
  @if (company().id && idPortal() === '2') {
    <div class="card flex justify-center">
      <p-select
        [(ngModel)]="selectedCompany"
        [options]="companies"
        (onChange)="onCompanySelected($event.value)"
        optionLabel="searchLabel"
        [filter]="true"
        [filterBy]="'id,label,searchLabel'"
        [styleClass]="'company-btn'"
        [placeholder]="'Buscar empresa'"
        [showClear]="false"
        appendTo="body"
      >
        <ng-template let-client pTemplate="item">
          <div class="flex align-items-center">
            <i class="pi pi-building text-sm"></i>&nbsp;&nbsp;
            <span>{{ client.searchLabel }}</span>
          </div>
        </ng-template>
        <ng-template let-client pTemplate="selectedItem">
          <div class="d-flex align-items-center">
            <i class="pi pi-building m-r-8"></i>
            <span>{{ client.searchLabel }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  }

  <!-- Indicador global de pre-nómina en ejecución: solo portal Empresas -->
  @if (idPortal() === '2') {
    <app-prenomina-global-indicator></app-prenomina-global-indicator>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Guía de usuario (panel lateral derecho) -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    aria-label="Guía de usuario"
    matTooltip="Guía de usuario"
    class="d-flex align-items-center justify-content-center"
    (click)="abrirGuia()"
  >
    <i class="iconify icon-20 d-flex" data-icon="solar:question-circle-outline"></i>
  </button>

  @if (options.theme == 'light') {
    <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center" (click)="setlightDark('dark')">
      <i-tabler class="d-flex icon-20" [name]="'moon'"></i-tabler>
    </button>
  } @else {
    <button mat-icon-button aria-label="lightdark" class="d-flex justify-content-center" (click)="setlightDark('light')">
      <i-tabler class="d-flex icon-20" [name]="'sun'"></i-tabler>
    </button>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Notifications Dropdown (Chatwoot + Pre-nómina) -->
  <!-- --------------------------------------------------------------- -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="notificationmenu"
    (menuOpened)="onNotificationsOpened()"
    aria-label="Notifications"
    class="d-flex align-items-center justify-content-center m-r-5 position-relative"
  >
    <i class="iconify icon-20 d-flex" data-icon="solar:bell-line-duotone"></i>
    @if (totalBellUnread() > 0) {
      <span class="chatwoot-bell-badge">
        {{ totalBellUnread() > 9 ? '9+' : totalBellUnread() }}
      </span>
    }
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">Notificaciones</h6>
      @if (totalBellUnread() > 0) {
        <span class="m-l-auto">
          <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">
            {{ totalBellUnread() }} nueva{{ totalBellUnread() === 1 ? '' : 's' }}
          </span>
        </span>
      }
    </div>

    <!-- ── Sección: procesos de pre-nómina ── -->
    @if (preNominaNotifs().length > 0) {
      <div class="d-flex align-items-center p-x-32 p-y-8">
        <span class="f-s-12 f-w-600 text-muted text-uppercase">Procesos de nómina</span>
        <button
          mat-button
          class="m-l-auto f-s-11 text-muted"
          (click)="clearPreNominaNotifs(); $event.stopPropagation()"
        >
          Limpiar
        </button>
      </div>
      @for (n of preNominaNotifs(); track n.id) {
        <button mat-menu-item class="p-x-30 p-y-12" (click)="openPreNominaNotif(n)">
          <div class="d-flex align-items-center">
            <span
              class="flex-shrink-0 rounded-circle icon-48 d-flex align-items-center justify-content-center"
              [class.text-success]="n.estado === 'Completado'"
              [class.bg-light-success]="n.estado === 'Completado'"
              [class.text-error]="n.estado === 'Error'"
              [class.bg-light-error]="n.estado === 'Error'"
            >
              <i-tabler
                [name]="n.estado === 'Completado' ? 'circle-check' : 'alert-triangle'"
                class="icon-20 d-flex"
              ></i-tabler>
            </span>
            <div class="m-l-16 w-100">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="f-s-14 f-w-600 m-0 text-truncate">{{ n.title }}</h5>
                <span class="f-s-11 text-muted m-l-8">{{ n.time }}</span>
              </div>
              <span class="d-block text-truncate f-s-12 w-75">{{ n.subtitle }}</span>
            </div>
          </div>
        </button>
      }
    }

    <!-- ── Sección: paquetes documentales (Jurídica) listos para descargar ── -->
    @if (paquetesPendientes().length > 0) {
      <div class="d-flex align-items-center p-x-32 p-y-8">
        <span class="f-s-12 f-w-600 text-muted text-uppercase">Paquetes documentales</span>
      </div>
      @for (p of paquetesPendientes(); track p.id) {
        <button mat-menu-item class="p-x-30 p-y-12" (click)="openPaqueteDocumentalNotif(p)">
          <div class="d-flex align-items-center">
            <span
              class="flex-shrink-0 text-success bg-light-success rounded-circle icon-48 d-flex align-items-center justify-content-center"
            >
              <i-tabler name="file-check" class="icon-20 d-flex"></i-tabler>
            </span>
            <div class="m-l-16 w-100">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="f-s-14 f-w-600 m-0 text-truncate">Paquete listo para descargar</h5>
              </div>
              <span class="d-block text-truncate f-s-12 w-75">
                {{ periodoPaquete(p) }}
              </span>
            </div>
          </div>
        </button>
      }
    }

    <!-- ── Sección: facturación pendiente de aprobación (AIU dinámico, HAG-152) ── -->
    @if (facturacionPendientes().length > 0) {
      <div class="d-flex align-items-center p-x-32 p-y-8">
        <span class="f-s-12 f-w-600 text-muted text-uppercase">Facturación por aprobar</span>
      </div>
      @for (c of facturacionPendientes(); track c.id) {
        <button mat-menu-item class="p-x-30 p-y-12" (click)="openFacturacionPendienteNotif(c)">
          <div class="d-flex align-items-center">
            <span
              class="flex-shrink-0 text-warning bg-light-warning rounded-circle icon-48 d-flex align-items-center justify-content-center"
            >
              <i-tabler name="file-invoice" class="icon-20 d-flex"></i-tabler>
            </span>
            <div class="m-l-16 w-100">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="f-s-14 f-w-600 m-0 text-truncate">Facturación por aprobar</h5>
              </div>
              <span class="d-block text-truncate f-s-12 w-75">
                {{ etiquetaFacturacion(c) }}
              </span>
            </div>
          </div>
        </button>
      }
    }

    <!-- ── Sección: mensajes (Chatwoot) — solo roles con chat habilitado (admin-chat) ── -->
    @if (chatHabilitado()) {
    <div class="p-x-32 p-y-8">
      <span class="f-s-12 f-w-600 text-muted text-uppercase">Mensajes</span>
    </div>
    @if (chatwootPending().length === 0 && chatwootInboxPending().length === 0) {
      <div class="p-x-32 p-y-16 text-muted f-s-13">Sin mensajes pendientes.</div>
    } @else {
      @for (c of chatwootPending(); track c.conversationId) {
        <button mat-menu-item class="p-x-30 p-y-12" (click)="openChatwootConversation(c)">
          <div class="d-flex align-items-center">
            <span
              class="flex-shrink-0 text-success bg-light-success rounded-circle icon-48 d-flex align-items-center justify-content-center"
            >
              <i-tabler name="brand-whatsapp" class="icon-20 d-flex"></i-tabler>
            </span>
            <div class="m-l-16 w-100">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="f-s-14 f-w-600 m-0 text-truncate">{{ c.senderName || c.nombre }}</h5>
                <span class="bg-error text-white p-x-8 p-y-2 rounded f-s-11 f-w-600 m-l-8">{{ c.count }}</span>
              </div>
              <span class="d-block text-truncate f-s-12 w-75">{{ c.preview || 'Nuevo mensaje' }}</span>
            </div>
          </div>
        </button>
      }
      <!-- ── Bandeja global: respuestas de campaña / WhatsApp sin candidato ── -->
      @for (c of chatwootInboxPending(); track c.conversationId) {
        <button mat-menu-item class="p-x-30 p-y-12" (click)="openInboxConversation(c)">
          <div class="d-flex align-items-center">
            <span
              class="flex-shrink-0 text-primary bg-light-primary rounded-circle icon-48 d-flex align-items-center justify-content-center"
            >
              <i-tabler [name]="c.campanaNombre ? 'speakerphone' : 'brand-whatsapp'" class="icon-20 d-flex"></i-tabler>
            </span>
            <div class="m-l-16 w-100">
              <div class="d-flex align-items-center justify-content-between w-100">
                <h5 class="f-s-14 f-w-600 m-0 text-truncate">{{ c.nombre }}</h5>
                <span class="d-flex align-items-center flex-shrink-0 m-l-8">
                  <span class="bg-light-primary text-primary p-x-8 p-y-2 rounded f-s-10 f-w-600 m-r-4">
                    {{ c.campanaNombre ? 'Campaña' : 'WhatsApp' }}
                  </span>
                  <span class="bg-error text-white p-x-8 p-y-2 rounded f-s-11 f-w-600">{{ c.unreadCount }}</span>
                </span>
              </div>
              <span class="d-block text-truncate f-s-12 w-75">
                {{ c.campanaNombre ? 'Campaña: ' + c.campanaNombre : c.phone }}
              </span>
            </div>
          </div>
        </button>
      }
    }
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button [matMenuTriggerFor]="flags" mat-icon-button>
    <img
      [src]="selectedLanguage.icon"
      class="rounded-circle object-cover icon-20"
    />
  </button> -->
  <mat-menu #flags="matMenu" class="cardWithShadow">
    @for (lang of languages; track lang.icon) {
      <button mat-menu-item (click)="changeLanguage(lang)">
        <div class="d-flex align-items-center">
          <img [src]="lang.icon" class="rounded-circle object-cover m-r-8 icon-20" />
          <span class="f-s-14">{{ lang.language }}</span>
        </div>
      </button>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-button [matMenuTriggerFor]="profilemenu" aria-label="Profile" class="profile-btn">
    <div class="d-flex align-items-center gap-4">
      <span
        class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center icon-35 profile-dd"
        style="width: 35px; height: 35px; font-size: 1.3rem; font-weight: 600"
      >
        {{ nameInitials }}
      </span>

      <i data-icon="solar:alt-arrow-down-bold" class="iconify f-s-8"></i>
    </div>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="p-x-32 p-y-16">
      <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
        <span
          class="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center icon-35 profile-dd"
          style="width: 35px; height: 35px; font-size: 1.3rem; font-weight: 600"
        >
          {{ nameInitials }}
        </span>
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0 d-flex align-items-center">
            {{ userData()?.nombre }}
            <!-- <span class="f-s-14 d-block text-success m-l-4">Pro</span> -->
          </h6>
          <span class="text-muted"> {{ userData()?.email | lowercase }} </span>
        </div>
      </div>
    </div>
    <div class="p-x-32 p-b-16">
      @for (profile of profiledd; track profile.title) {
        <a class="p-1 text-decoration-none d-block text-hover-primary" (click)="handleProfileClick(profile)" [routerLink]="[profile.link]">
          <div class="d-flex align-items-center">
            <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text">
              {{ profile.title }}
            </h5>
            @if (profile.new) {
              <span class="bg-light-error text-error rounded p-x-8 p-y-2 f-w-500 f-s-12 m-l-4">5</span>
            }
          </div>
        </a>
      }
    </div>
  </mat-menu>
</mat-toolbar>
